import React, { createRef } from 'react'
import { renderReport } from '../components/elementList';
import FormComponent from '../components/formComponent';
import StepManager from '../components/stepManager'
import UiFieldEntity from './uiFieldEntity'

class UiField extends React.Component {

    static defaultProps = {
        FIELDTYPE: 'acuadori field',
        customer: {}
    };

    constructor(props) {
        super(props);

        this.assetService = props.services.asset;
        this.customerService = props.services.customer;

        this.stepManagerRef = createRef();

        this.state = {
            asset: null,
            attributes: null,
            fieldEntities: [],
            stepList: this.makeSteps()
        };
    }

    makeSteps = () => {
        let { instances } = this.props.customer
        let steps = [
            {
                stepId: 0, stepName: 'Set Field Name', formValue: this.renderAssetMainForm, dataValue: () => renderReport(this.reportAsset()),
                documentation: {
                    brief: 'Choose the name of the field',
                    content: 'The customer name is automatically pre-posted to the field\'s name. The thingsboard asset is created in this step.'
                }
            },
            {
                stepId: 1, stepName: 'Add Field Attributes', formValue: this.renderAddServerAttributes, dataValue: () => renderReport(this.reportAssetAttributes()),
                documentation: {
                    brief: 'Insert the field\'s coordinates.',
                    content: <p>Coordinates is the field's perimeter. Should be inserted in the form
                        <span className='text-info'> [[lat1, lon1], [latP2, lonP2], ...] </span>.
                        Coordinates is inserted as Thingsboard Asset attribute.
                        <i> Latitude</i> and <i>Longitude</i> will be automatically calculated as perimeter's center and
                        added as attributes to the Thingsboard field's asset.</p>
                }
            }
        ];
        for (let i = 0; i < instances.length; i++) {
            let item = instances[i];
            let step = {
                stepId: i + 2,
                stepName: `Connect ${item.name} Field to Customer`,
                documentation: {
                    brief: `Creates the ${item.name} EntityView`,
                    content: <p>After creating the field's EntityView, it is <i>assigned</i> to the corresponding customer and a
                    <i> Contains relation</i> is created betwen the EntityView and the customer.</p>
                },
                formValue: () => this.renderAssetEntity(item)
            };
            steps.push(step);
        }
        return steps;
    };

    stepManagerAdvance = () => {
        const element = this.stepManagerRef.current;
        element.advance(() => {
            if (element.isEnd()) {
                this.props.finished(this.state.asset, this.reportAllComponentData());
            }
        });
    };

    reportAsset = () => {
        let { asset } = this.state;
        if (!asset) {
            return null;
        }
        let data = [
            { key: 'ID', value: asset.id.id },
            { key: 'NAME', value: asset.name },
            { key: 'TYPE', value: asset.type }
        ];
        return data;
    };

    reportAssetAttributes = () => {
        let { attributes } = this.state;
        if (!attributes) {
            return null;
        }
        let attr = [];
        for (let i = 0; i < attributes.length; i++) {
            let newVal = { key: attributes[i].key, value: attributes[i].value };
            newVal.key = newVal.key.toUpperCase();
            attr.push(newVal);
        }
        return attr;
    }

    reportFieldEntities = () => {
        let { fieldEntities } = this.state;


        let data = [];
        for (let i = 0; i < fieldEntities.length; i++) {
            fieldEntities[i].report.forEach(value => data.push(value))
        }
        return data;
    }

    reportAllComponentData = () => {
        let { fieldEntities } = this.state;
        let data = [];
        this.reportAsset().forEach(value => data.push(value));
        this.reportAssetAttributes().forEach(value => data.push(value));
        for (let i = 0; i < fieldEntities.length; i++) {
            fieldEntities[i].report.forEach(value => data.push(value))
        }
        return data.length > 0 ? data : null;
    }

    handleValidate = (values) => {
        const errors = {};
        if (!values.name) {
            errors.name = 'Required';
        }
        return errors;
    };

    handleAssetSubmit = (values) => {
        let formData = values;
        let assetName = this.props.customer.name + ' ' + formData.name;
        formData = { name: assetName, type: this.props.FIELDTYPE };
        return this.assetService.addAsset(formData).then((response) => {
            this.setState({ asset: response });
            this.renderAlert('Asset saved', 'success');
            this.stepManagerAdvance();
        }).catch(this.handleSubmitError);
    };

    handleAttributesSubmit = (values) => {
        let { asset } = this.state;
        let attributes = { coordinates: values.coordinates, latitude: 0.0, longitude: 0.0 };
        if (attributes.coordinates !== '') {
            let coords = JSON.parse(values.coordinates);
            let lat = [];
            let lon = [];
            for (let i = 0; i < coords.length; i++) {
                lat.push(coords[i][0]);
                lon.push(coords[i][1]);
            }
            if (lat) {
                const sum = lat.reduce((a, b) => { return a + b }, 0);
                const avg = (sum / lat.length) || 0.0;
                attributes.latitude = avg;
            }
            if (lon) {
                const sum = lon.reduce((a, b) => { return a + b }, 0);
                const avg = (sum / lon.length) || 0.0;
                attributes.longitude = avg;
            }
        }
        return this.assetService.addServerAttributes(attributes, asset.id.id).then((response) => {
            this.renderAlert('Attributes saved', 'success');
            return this.handleNewAssetData();
        }
        ).catch(this.handleSubmitError);
    };

    handleNewAssetData = () => {
        let { asset } = this.state;
        return this.assetService.getAssetById(asset.id.id).then((response) => {
            this.setState({ asset: response });
        }
        ).then(() => {
            return this.assetService.getAssetAttributesById(asset.id.id).then((response) => {
                this.setState({ attributes: response });
                this.stepManagerAdvance();
            });
        }
        );
    };

    handleSubmitError = (error) => {
        let message = 'Error: ' + error.message;
        this.renderAlert(message, 'warning');
    };

    renderAssetMainForm = () => {
        return (
            <div>
                <FormComponent
                    initialValues={{ name: '', type: '', label: '', description: '' }}
                    validateFunc={this.handleValidate}
                    submitFunc={this.handleAssetSubmit}
                    inputs={[
                        { key: 'name', type: 'text', inputType: 'input', placeholder: 'Name', label: 'Name', fixedPre: this.props.customer.name },
                    ]}
                />
            </div>
        );
    };

    renderAddServerAttributes = () => {

        return (
            <div>
                <FormComponent
                    initialValues={{ latitude: '', longitude: '', coordinates: '' }}
                    validateFunc={this.handleAttributesValidate}
                    submitFunc={this.handleAttributesSubmit}
                    inputs={[
                        { key: 'coordinates', type: 'text', inputType: 'input', placeholder: 'Coordinates', label: 'Coordinates' }
                    ]}
                />
            </div>
        );
    };



    renderAssetEntity = (customer) => {
        let { asset } = this.state;

        return (
            <UiFieldEntity
                finished={(assetEntityData, report) => {
                    let { fieldEntities } = this.state;
                    fieldEntities.push({ data: assetEntityData, report: report });
                    this.setState({ fieldEntities: fieldEntities });
                    this.stepManagerAdvance();
                }}
                error={this.handleSubmitError}
                services={{ asset: this.assetService, customer: this.customerService }}
                customer={{ name: customer.name, id: customer.id }}
                field={asset}
                type={{ name: customer.type.name, fixedPre: customer.type.fieldPre, fixedPost: customer.type.fieldPost }}
            />
        );
    };


    renderAlert = (message, variant) => {
        this.stepManagerRef.current.showAlert(message, variant);
    };

    render() {
        let { stepList } = this.state;

        return (
            <div className="container">
                <StepManager ref={this.stepManagerRef}
                    alert={{ active: true }}
                    progressBar={{ active: true }}

                    startStepId={0} endStepId={stepList.length - 1}

                    onFinished={() => {
                        //window.open( this.props.links.thingsboardRoutes.dashboards );
                        this.setState({ finished: true })
                    }}

                    stepList={stepList}
                />
            </div>
        );
    }
}

export default UiField;
